import React, { useState, useEffect } from 'react';
import './Nav.css';

export default function Nav({ onRsvp, activeSection, onNavigate }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => { 
    setMenuOpen(false); 
  }, [activeSection]);

  const handleNavClick = (sectionId) => {
    setMenuOpen(false);
    onNavigate(sectionId);
  };

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'info', label: 'Info' },
    { id: 'catering', label: 'Catering' },
    { id: 'gifting', label: 'Gifting' },
  ];

  return (
    <nav className="nav">
      <button 
        className="nav__brand"
        onClick={() => handleNavClick('home')}
        type="button"
      >
        <span className="nav__brand-names">Ayo <em>♥</em> Ayo</span>
      </button>
      <ul className="nav__links">
        {navItems.map(item => (
          <li key={item.id}>
            <button 
              onClick={() => handleNavClick(item.id)}
              className={activeSection === item.id ? 'active' : ''}
              type="button"
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>

      <button className="nav__burger" onClick={() => setMenuOpen(v => !v)} aria-label="Menu" type="button">
        <span /><span /><span />
      </button>
      <div className={`nav__drawer ${menuOpen ? 'nav__drawer--open' : ''}`}>
        {navItems.map(item => (
          <button
            key={item.id}
            onClick={() => handleNavClick(item.id)}
            className={activeSection === item.id ? 'active' : ''}
            type="button"
          >
            {item.label}
          </button>
        ))}
      </div>
    </nav>
  );
}